(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-tiles-carousel')) {
    customElements.define(
      'promo-tiles-carousel',
      class PromoTilesCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-promo-tiles-track]');
          if (!this.track) return;

          this.previousButton = this.querySelector('[data-promo-tiles-prev]');
          this.nextButton = this.querySelector('[data-promo-tiles-next]');
          this.update = this.update.bind(this);

          this.previousButton?.addEventListener('click', () => this.step(-1));
          this.nextButton?.addEventListener('click', () => this.step(1));
          this.track.addEventListener('scroll', this.update, { passive: true });

          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        /* Advance by exactly one tile so the snap points always line up. */
        step(direction) {
          const tile = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const distance = tile ? tile.getBoundingClientRect().width + gap : this.track.clientWidth;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        update() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const overflows = scrollWidth - clientWidth > 1;

          if (this.previousButton) this.previousButton.hidden = !overflows || scrollLeft <= 1;
          if (this.nextButton) this.nextButton.hidden = !overflows || scrollLeft >= scrollWidth - clientWidth - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
